import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { AlertCircleIcon, CheckIcon, ClockIcon } from "../../icons";
import { Loader } from "../general/Loader";
import {
    documentBeingProcessed,
    IMPORTER_ERROR_MESSAGES,
    isAccountDataPresent,
} from "./helpers";
import { ImporterDocumentImportStatus, ImporterDocumentRow } from "./types";

interface Props {
    documentRow: ImporterDocumentRow;
}

export const ImporterDocumentStatus: React.FC<Props> = ({ documentRow }) => {
    if (!documentRow.financialDocument) {
        return (
            <>
                <Loader inline />
                Uploading
            </>
        );
    }

    if (documentBeingProcessed(documentRow.financialDocument)) {
        return (
            <>
                <Loader inline />
                Processing
            </>
        );
    }

    if (documentRow.importStatus === ImporterDocumentImportStatus.FINISHED) {
        return (
            <span className="text-blue-600">
                <CheckIcon className="mr-2 icon-color-blue-600" />
                Imported
            </span>
        );
    }

    if (documentRow.importStatus === ImporterDocumentImportStatus.SCHEDULED) {
        return (
            <span>
                <ClockIcon className="mr-2" />
                Import scheduled
            </span>
        );
    }

    if (documentRow.importStatus === ImporterDocumentImportStatus.IN_PROGRESS) {
        return (
            <span>
                <Loader inline />
                Importing
            </span>
        );
    }

    if (documentRow.financialDocument.numTransactions === 0) {
        return (
            <span className="text-yellow-600">
                <AlertCircleIcon className="mr-2 icon-color-yellow-600" />
                No transactions found
            </span>
        );
    }

    if (
        documentRow.financialDocument.importerErrors &&
        documentRow.financialDocument.importerErrors.length === 1
    ) {
        return (
            <span className="text-yellow-600">
                <AlertCircleIcon className="mr-2 icon-color-yellow-600" />
                {
                    IMPORTER_ERROR_MESSAGES[
                        documentRow.financialDocument.importerErrors[0]
                    ]
                }
            </span>
        );
    }

    if (
        documentRow.financialDocument.importerErrors &&
        documentRow.financialDocument.importerErrors.length > 1
    ) {
        return (
            <OverlayTrigger
                overlay={
                    <Tooltip id={"errorsTooltip" + documentRow.id.toString()}>
                        <ul className="m-0 pl-4">
                            {documentRow.financialDocument.importerErrors.map(
                                (error) => (
                                    <li key={error}>
                                        {IMPORTER_ERROR_MESSAGES[error]}
                                    </li>
                                ),
                            )}
                        </ul>
                    </Tooltip>
                }
            >
                <span className="text-yellow-600">
                    <AlertCircleIcon className="mr-2 icon-color-yellow-600" />
                    {documentRow.financialDocument.importerErrors.length} errors
                </span>
            </OverlayTrigger>
        );
    }

    if (
        documentRow.integrationAccount &&
        !isAccountDataPresent(documentRow.integrationAccount)
    ) {
        return (
            <span className="text-yellow-600">
                <AlertCircleIcon className="mr-2 icon-color-yellow-600" />
                Fill account info and select entity
            </span>
        );
    }

    return (
        <span className="text-blue-600">
            <CheckIcon className="mr-2 icon-color-blue-600" />
            Processed
        </span>
    );
};
